<template>
<div class="swiperBox">
  <swiper :options="swiperOption" ref="mySwiper">
  <!-- slides -->
      <swiper-slide >
         <div class="center">
           <img src="../assets/images/ostart.png" alt="" style="margin-top:2.4rem">
           <p>共享为您带来更多惊喜</p>
           <span>您和您的家人,朋友可以共享1张会员卡</span>
         </div>
      </swiper-slide>
      <swiper-slide>
       <div class="center">
           <img src="../assets/images/tstart.png" alt="">
           <p>负担得起的海滩胜地</p>
           <span>“一个沙滩一个吊床,会员VIP轻松搞定”</span>
         </div>
        </swiper-slide>
      <swiper-slide>
        <div class="center">
           <img src="../assets/images/thstart.png" alt="">
           <p>大路小径任您选</p>
           <span>一张会员VIP让您和你的家人，朋友一起</span>
           <span class="home">享受贵宾待遇</span>
           <router-link :to="{ path: 'login'}"  tag="div">
            <a>进 入</a>
            </router-link>
         </div>
      </swiper-slide>
     
        <div class="swiper-pagination"  slot="pagination" v-if="oneActive" ></div>

  </swiper>
  </div>
</template>
<script>

import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
 components: {
 swiper,
 swiperSlide
},
 data() {
   var self=this;
   return {
        oneActive:true,
        notNextTick: true,
        swiperOption:{
             on:{
                transitionStart:function(){
                  if(this.isEnd){
                         self.oneActive=false
                  }
                  console.log(self)
                }       
                    },
                onSlideChangeEnd:swiper=>{
                    alert(swiper.isEnd)
                    
              },
        pagination : {
         el:'.swiper-pagination'
          },
          loop:false,
          disableOnInteraction:true,
          autoplay: false,
          stopOnLastSlide:false,
          slidesPerView:"auto",
          centeredSlides:true,
          // direction : 'vertical',
          // autoHeight: true,
          // paginationType:"bullets",
          paginationClickable :true,
          spaceBetween:30,
          onSlideChangeEnd:swiper=>{
          this.page=swiper.realIndex+=1;
          this.index=swiper.realIndex
      }
     }
   }
 },
 computed: {
   swiper() {
     return this.$refs.mySwiper.swiper
   }
 },
 mounted() {
  var that=this;
  this.swiper.slideTo(0,0,false)
  }
 }
</script>
<style>
.swiper-slide{
  width: 100%;
  height:13.34rem;
  /* background: gray; */
  /* margin-right: 0 !important; */
}
.swiper .swiper-slide:nth-child(2) img{
  margin-top:1rem
}
.center{
  width: 100%;
  text-align: center;
  font-size: 0.3rem;
  color: #2EA4B0;
  }
  .center img{
    width:4.5rem;
    height: auto;
    display: inline-block;
    margin: 2rem 0 0.39rem 0;
  }
   .center span{
     font-size: 0.5rem;
     color: #e7e7e7;
     display:block;
     margin-top: 0.3rem;
  }
  p{
    font-size: 0.5rem;
   /* margin-top: 0.5rem */
  }
  .center .home{
    margin-top: 0.1rem !important;
  }
  .center a{
     display: inline-block;
    text-decoration: none;
    width: 4rem;
    height: 1.2rem;
    background-image: linear-gradient(to right, #2EA4B0, #06789D);
    color: white;
    text-align: center;
    line-height:1.2rem;
    border-radius: 50px;
    margin-top:5.2rem;
    font-size: 0.55rem
  }
  .swiper-pagination{
    width: 1rem;
    height:1rem;
    position: absolute;
    top: 70%;
    left:2rem;

  }
  .swiperBox{
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue